<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="4" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker locale="vi" id="datepicker" v-model="dateRange" :model-config="dateRangeConfig" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="4" md="4" xl="2">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Lấy bản tin TW'"
              class="btn-action-primary"
              @click="submitGetFileTW()">
              <i class="fa fa-download"></i>&nbsp;&nbsp; Lấy bản tin TW
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>


          <template #createDate="{item}">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null">

            </td>
          </template>
          <template #twRequestDate="{item}">
            <td v-if="item.twRequestDate != null">
              {{ item.twRequestDate }}
            </td>
            <td v-if="item.twRequestDate == null">

            </td>
          </template>
          <template #level="{item}">
            <td>
              <span class="badge badge-success" v-if="item.level == 0">Bình thường</span>
              <span class="badge badge-warning" v-if="item.level == 1">Ưu tiên</span>
              <span class="badge badge-danger" v-if="item.level == 2">Khẩn cấp</span>
            </td>
          </template>
          <template #url="{item}">
            <td v-if="item.url != null">
              <!--              <a :href="item.url" target="_blank">Ấn vào để xem tệp</a>-->
              <span class="view-file" @click="viewFile(item.url)">Ấn vào để xem tệp</span>
            </td>
            <td v-else></td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Tải xuống'"
                  square
                  size="sm"
                  @click="downloadFile(item.url)"><i class="fa fa-download"></i>
                </CButton>
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Gửi tới nhóm bảng điện tử'"
                  square
                  size="sm"
                  @click="sendToStation(item)"><i class="fa fa-send"></i>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../../base/BaseDataTable";
import ModalConfirm from "../../base/BaseModalConfirm";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2"
import {sourceType} from "../../../constant";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";

export default {
  name: "ScreenFileList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();
    return {
      loading: {
        value: false
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileSelectedId: null,
          fileSelectedName: null,
          listFileSelectedId: []
        }
      },
      dateRange: {
        start: this.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề tệp tin",
          label: 'Tiêu đề tệp tin'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      sourceType: {
        data: {
          name: "sourceType",
          model: sourceType.TRUNG_UONG,
        }
      },
      mainTable: {
        options: {
          fields: [
            // {key: "checkbox", label: "#"},
            {key: "index", label: "STT"},
            {key: "createDate", label: "Ngày tạo"},
            {key: "title", label: "Tiêu đề"},
            {key: "description", label: "Mô tả"},
            {key: "level", label: "Cấp độ"},
            {key: "url", label: "Tệp"},
            {key: "twRequestDate", label: "Thời điểm yêu cầu đăng tải"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["index", "createDate", "action", "level", "url", "twRequestDate"],
        },
        dataSource: {
          url: "/screen-file/getPages",
          dataSubmit: function () {
            return {
              name: that.titleInput.data.model,
              sourceType: that.sourceType.data.model,
              fromDate: that.$helper.formatDate(that.dateRange.start),
              toDate: that.$helper.formatDate(that.dateRange.end),
            };
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    submitGetFileTW() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/sync-tw/get-file",
        dataSubmit: function () {
          return {type: "Digital"}
        },
        ignoreDefaultData: true,
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {

          } else {
            that.showErrorMsg({message: 'Lấy bản tin từ TW thất bại'});
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    async viewFile(url) {
      // let that = this;
      // this.loading.value = true;
      // const data = await this.$helper.blobFileByUrl(url);
      // setTimeout(() => {
      //   that.loading.value = false;
      //   window.open(data)
      // }, 500)
      window.open(this.$helper.viewFileByUrl(url))
    },
    async downloadFile(url) {
      const file = await this.$helper.blobFileByUrl(url)
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.href = file
      a.download = url.substring(url.lastIndexOf("/") + 1, url.length)
      a.click()
      URL.revokeObjectURL(file)
    },
    sendToStation: function (item) {
      let that = this
      that.$router.push({
        name: 'Gửi nội dung phát tới nhóm tệp tin điện tử',
        query: {fileId: item.id, sourceType: item.sourceType}
      })
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
